(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/components/package-closed-info.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/components/package-closed-info.js');

'use strict';

const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const PackageClosedInfo = () => {
  const regCloseTime = useSelector(state => state.numbergames.draws[0].regCloseTime);
  const openTime = svs.utils.date.FormatTime(undefined, regCloseTime);
  return React.createElement("p", {
    className: "gp-closed-info-text"
  }, "L\xF6rdagsgodis \xE4r st\xE4ngt f\xF6r spel. ", React.createElement("br", null), "V\xE4lkommen tillbaka ", openTime, " f\xF6r spel p\xE5 n\xE4sta l\xF6rdag.");
};
svs.gamePackage.components.PackageClosedInfo = PackageClosedInfo;

 })(window);